/* eslint-disable no-unused-vars */
import ErrorModal from 'components/modal/errorModal';
import UploadModal from 'components/modal/uploadModal';
import { UseFileListIntrface } from 'hooks/files/useFileList';
import { PreviewMap } from 'pages/upload/upload';
import React from 'react';
import { getMIMEType, isImageFormat, shieldFileName } from 'utils/utils';

export type SetUploadModalProps = {
  originalId: string;
  previewList: UseFileListIntrface;
  setPreviewMap: (value: React.SetStateAction<PreviewMap>) => void;
  setCurrentModal: (
    value: React.SetStateAction<React.ReactElement<
      any,
      string | React.JSXElementConstructor<any>
    > | null>
  ) => void;
};

export const setUploadModal = ({
  originalId,
  setCurrentModal,
  setPreviewMap,
  previewList,
}: SetUploadModalProps) => {
  const setUploadedFile = (file: File | undefined) => {
    if (file) {
      if (!isImageFormat(getMIMEType(file.name))) {
        setCurrentModal(
          <ErrorModal
            onClose={() => setCurrentModal(null)}
            errorText="Недопустимый формат для миниатюры"
          ></ErrorModal>
        );

        return;
      }

      const previewId = shieldFileName(file.name);

      setPreviewMap((old) => {
        return { ...old, [originalId]: previewId };
      });

      return file;
    }

    return false;
  };

  setCurrentModal(
    <UploadModal
      disableSetter={true}
      isMultiple={false}
      onClose={() => {
        setCurrentModal(null);
      }}
      onDrop={(e) => {
        const file = e.dataTransfer.files[0];

        if (setUploadedFile(file)) {
          previewList.onDrop(e);
        }
      }}
      onChange={(e) => {
        const file = e.target.files?.[0];

        if (file && setUploadedFile(file)) {
          previewList.onBrowse(e);
        }
      }}
    ></UploadModal>
  );
};
